import { Palette, Package, Layers, Gamepad2, Boxes, Stethoscope, type LucideIcon } from 'lucide-react';

export interface NavItem {
  path: string;
  label: string;
  icon: LucideIcon;
  accent: string;
  dot: string;
  glow: string;
}

export const NAV_ITEMS: NavItem[] = [
  { path: '/creation', label: '创作中心', icon: Palette, accent: 'text-neon-yellow', dot: 'bg-neon-yellow shadow-[0_0_6px_hsl(var(--neon-yellow))]', glow: 'drop-shadow-[0_0_6px_hsl(var(--neon-yellow)/0.6)]' },
  { path: '/playables', label: '试玩列表', icon: Gamepad2, accent: 'text-neon-cyan', dot: 'bg-neon-cyan shadow-[0_0_6px_hsl(var(--neon-cyan))]', glow: 'drop-shadow-[0_0_6px_hsl(var(--neon-cyan)/0.6)]' },
  { path: '/batch', label: '创意工厂', icon: Layers, accent: 'text-neon-purple', dot: 'bg-neon-purple shadow-[0_0_6px_hsl(var(--neon-purple))]', glow: 'drop-shadow-[0_0_6px_hsl(var(--neon-purple)/0.6)]' },
  { path: '/materials', label: '资产库', icon: Package, accent: 'text-neon-pink', dot: 'bg-neon-pink shadow-[0_0_6px_hsl(var(--neon-pink))]', glow: 'drop-shadow-[0_0_6px_hsl(var(--neon-pink)/0.6)]' },
  { path: '/components', label: '组件图鉴', icon: Boxes, accent: 'text-neon-green', dot: 'bg-neon-green shadow-[0_0_6px_hsl(var(--neon-green))]', glow: 'drop-shadow-[0_0_6px_hsl(var(--neon-green)/0.6)]' },
  { path: '/doctor', label: '试玩诊断', icon: Stethoscope, accent: 'text-neon-cyan', dot: 'bg-neon-cyan shadow-[0_0_6px_hsl(var(--neon-cyan))]', glow: 'drop-shadow-[0_0_6px_hsl(var(--neon-cyan)/0.6)]' },
];

export const PAGE_TITLES: Record<string, string> = {
  '/creation': '创作中心',
  '/playables': '试玩列表',
  '/materials': '资产库',
  '/batch': '创意工厂',
  '/components': '组件图鉴',
  '/doctor': '试玩诊断',
};
